import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type {
  CurriculumState,
  LoadGoalsForCurriculumParamsPayload,
  RemoveCustomSectionPayload,
  SetBaseGoalOccurencePayload,
  SetSelectedItemsPayload,
  SetSelectionModePayload,
  SetSelectionOptionsPayload,
  SetUrlParamsPayload,
  ToggleSelectedItemPayload,
} from './curriculumTypes';

function init(): CurriculumState {
  return {
    curriculumKey: '',
    curriculumLoading: false,
    isFailed: false,
    preview: false,
    selectionMode: false,
    selectionOptions: {
      allowSubitem: false,
      allowOptional: false,
      readonlyMode: false,
    },
    selectedItems: null,
    baseGoalOccurence: null,
    custids: [],
    studids: [],
    groupid: null,
    setid: null,
  };
}

const initialState = init();

const curriculumState = createSlice({
  name: 'curriculum',
  initialState,
  reducers: {
    setUrlParams: (state, action: PayloadAction<SetUrlParamsPayload>) => {
      const { id, curriculumKey, custid, custids, studid, studids, groupid, setid, preview } =
        action.payload;
      state.curriculumKey = id || curriculumKey || '';
      state.custids = custids || custid?.split(',') || [];
      state.studids = studids || studid?.split(',') || [];
      state.groupid = groupid;
      state.setid = setid;
      state.preview = preview;
    },
    setSelectionMode: (state, action: PayloadAction<SetSelectionModePayload>) => {
      state.selectionMode = !!action.payload;
      if (action.payload === false) state.selectedItems = null;
    },
    setSelectedItems: (state, action: PayloadAction<SetSelectedItemsPayload>) => {
      state.selectedItems = action.payload;
    },
    toggleSelectedItem: (state, action: PayloadAction<ToggleSelectedItemPayload>) => {
      const { item } = action.payload;
      const itemHref = typeof item === 'string' ? item : item.href;
      const selectedItems = state.selectedItems || [];
      if (selectedItems?.some((g) => g.href === itemHref)) {
        state.selectedItems = selectedItems.filter((i) => i.href !== itemHref);
      } else {
        state.selectedItems = [...selectedItems, { href: itemHref }];
      }
    },
    setSelectionOptions: (state, action: PayloadAction<SetSelectionOptionsPayload>) => {
      state.selectionOptions = { ...state.selectionOptions, ...action.payload };
    },
    setBaseGoalOccurence: (state, action: PayloadAction<SetBaseGoalOccurencePayload>) => {
      const { goalOccurence } = action.payload;
      state.baseGoalOccurence = goalOccurence;
    },
    loadGoalsForCurriculumParams: (
      _state,
      _action: PayloadAction<LoadGoalsForCurriculumParamsPayload>,
    ) => {},
    removeCustomSection: (_state, _action: PayloadAction<RemoveCustomSectionPayload>) => {},
  },
});

export const curriculumActions = curriculumState.actions;
export const {
  setUrlParams,
  setSelectedItems,
  setSelectionOptions,
  toggleSelectedItem,
  setBaseGoalOccurence,
  loadGoalsForCurriculumParams,
  removeCustomSection,
} = curriculumState.actions;
export default curriculumState;
